import { Action } from 'redux';
import { ExtractionDisplayStatus, ListDocumentExtractionsOutput } from '../../types';
import { ExtractionSortDirection, SearchableExtractionFields } from '../types';

export const EXTRACTION_LIST_GET = 'extractionList/get';
export const EXTRACTION_LIST_LOADED = 'extractionList/loaded';
export const EXTRACTION_LIST_ERROR = 'extractionList/error';
export const EXTRACTION_LIST_PAGE_CHANGE = 'extractionList/pageChange';
export const EXTRACTION_LIST_SORT_CHANGE = 'extractionList/sortChange';
export const EXTRACTION_LIST_FILTER_CHANGE = 'extractionList/filterChange';

export interface ExtractionListGetAction extends Action {
    type: typeof EXTRACTION_LIST_GET;
}

export interface ExtractionListLoadedAction extends Action {
    type: typeof EXTRACTION_LIST_LOADED;
    payload: ListDocumentExtractionsOutput;
}

export interface ExtractionListErrorAction extends Action {
    type: typeof EXTRACTION_LIST_ERROR;
    payload: { error: any };
}

export interface ExtractionListPageChangeAction extends Action {
    type: typeof EXTRACTION_LIST_PAGE_CHANGE;
    payload: { currentPage: number; startAt: number };
}

export interface ExtractionListSortChangeAction extends Action {
    type: typeof EXTRACTION_LIST_SORT_CHANGE;
    payload: { sortColumn: string; sortDirection: ExtractionSortDirection };
}

export interface ExtractionListFilterChangeAction extends Action {
    type: typeof EXTRACTION_LIST_FILTER_CHANGE;
    payload: {
        statusFilter?: ExtractionDisplayStatus[];
        dateRange?: string[];
        query?: string;
        searchBy?: SearchableExtractionFields;
    };
}

export type ExtractionListActions =
    | ExtractionListGetAction
    | ExtractionListLoadedAction
    | ExtractionListErrorAction
    | ExtractionListPageChangeAction
    | ExtractionListSortChangeAction
    | ExtractionListFilterChangeAction;
